import { FcCheckmark } from "react-icons/fc";
import "./Career.css";

const CAREER_ENTRIES = [
  {
    id: "repliai",
    title: "Software Developer — RepliAi (Sep 2024 – Jun 2025)",
    skills:
      "Python · Django · REST APIs · PostgreSQL · Docker · GitHub Actions · AWS (EC2) · TypeScript · C#",
    highlights: [
      "Built and shipped Python backend services for an AI customer service platform.",
      "Designed RESTful APIs for TypeScript and C# clients; hardened auth with least-privilege access.",
      "Dockerized deployments and GitHub Actions CI/CD; PostgreSQL tuning and caching for throughput.",
      "Automated unit/integration testing to reduce regressions and improve release confidence.",
    ],
  },
  {
    id: "freelance",
    title: "Freelance Software Developer (Apr 2023 – Aug 2024)",
    skills: "Python · Flask · FastAPI · JavaScript · PostgreSQL · Docker",
    highlights: [
      "Delivered end-to-end web apps — requirements, design, implementation, testing, and deployment.",
      "Built REST APIs with Flask/FastAPI and relational schemas with SQL for reporting and performance.",
      "Implemented auth, validation, and secure data handling for customer-facing applications.",
    ],
  },
  {
    id: "proxi",
    title: "Pipeline TD / Full Stack Developer — PROXI VP (Nov 2021 – Mar 2023)",
    skills: "Python · AWS · Automation · Agile",
    highlights: [
      "Led delivery of 40+ Python automation and pipeline tools for VFX workflows, improving team productivity 20%+.",
      "Built artist-facing tooling, workflow automation, and monitoring for distributed production.",
      "Upgraded AWS infrastructure for distributed workloads; documented tools for team adoption.",
    ],
  },
];

const EDUCATION_ENTRIES = [
  {
    id: "masters-ai",
    title: "Master of Artificial Intelligence — QUT (2026)",
    skills: "In progress",
    highlights: [
      "Postgraduate study alongside industry experience in backend and ML systems.",
    ],
  },
  {
    id: "bachelor",
    title: "Bachelor of IT (Computer Science) — QUT (2015 – 2020)",
    skills: "Computer Science",
    highlights: [
      "Study abroad: Qingdao University (2018), Hanyang University (2019).",
    ],
  },
];

function CareerEntry({ title, skills, highlights = [] }) {
  return (
    <article className="career__details">
      <FcCheckmark className="career__details-icon" aria-hidden />
      <div>
        <h4>{title}</h4>
        <p className="career__skills text-light">{skills}</p>
        {highlights.length > 0 && (
          <ul className="career__highlights">
            {highlights.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        )}
      </div>
    </article>
  );
}

function CareerColumn({ title, entries }) {
  return (
    <div className="career__column">
      <h3>{title}</h3>
      <div className="career__content">
        {entries.map((entry) => (
          <CareerEntry key={entry.id} {...entry} />
        ))}
      </div>
    </div>
  );
}

export default function Career() {
  return (
    <section id="career" aria-labelledby="career-heading">
      <h5>Background</h5>
      <h2 id="career-heading">Career &amp; education</h2>
      <p className="section__lead">
        Backend and platform engineering in production, plus pipeline TD work for VFX
        at PROXI VP — and postgraduate AI study at QUT.
      </p>

      <div className="container career__container">
        <CareerColumn title="Experience" entries={CAREER_ENTRIES} />
        <CareerColumn title="Education" entries={EDUCATION_ENTRIES} />
      </div>
    </section>
  );
}
